import styled from 'styled-components'

import { ButtonPlain, type FocusVisibleProps, withFocusVisible } from '@subaio/components'

import { helpers } from '../../styles/theme'
import { focusVisibleOutline } from '../FocusVisible'

type Props = FocusVisibleProps & {
	isActive?: boolean
}

export const ButtonHeader = withFocusVisible(styled(ButtonPlain)<Props>`
	height: 30px;
	display: flex;
	align-items: center;
	column-gap: 6px;
	padding: 2px 10px 2px 4px;
	border-radius: 8px;
	color: ${helpers.color.button.background};
	position: relative;
	flex-shrink: 0;
	white-space: nowrap;
	width: fit-content;

	border: 2px solid ${({ isActive }) => (isActive ? helpers.color.button.backgroundTranslucent : 'transparent')};

	> svg {
		width: 22px;
		height: 22px;
		background-color: ${helpers.color.button.backgroundTranslucent};
		padding: 4px;
		border-radius: 8px;
		stroke-width: 2.5;
	}

	&:hover:not(:disabled) {
		background-color: ${helpers.color.button.backgroundTranslucent};

		> svg {
			background-color: transparent;
		}
	}

	&:disabled {
		> svg {
			background-color: ${helpers.color.button.backgroundDisabled};
		}
	}

	${focusVisibleOutline}
`)
